import { render, staticRenderFns } from "./ActiveSessionsModal.vue?vue&type=template&id=51789c7b&scoped=true"
import script from "./ActiveSessionsModal.vue?vue&type=script&lang=js"
export * from "./ActiveSessionsModal.vue?vue&type=script&lang=js"
import style0 from "./ActiveSessionsModal.vue?vue&type=style&index=0&id=51789c7b&prod&lagn=css&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51789c7b",
  null
  
)

export default component.exports